import React, { Fragment, useState, useEffect, useRef } from "react";
import ComponentCard from "../../Cards/ComponentCard/ComponentCard";
import PinInputList from "../PinInput/InputPinV2/InputList/PinInputList";
import PinOutputList from "../PinOut/OutputV2/OutputList/PinOutputList";
import classes from "./AppView.module.css";
import EditViewIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/EditView.svg";
import EditSiteIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/settings_white.png";
import EditPinsView from "./EditPinsView";
import PinsView from "./PinsView";
import PreviousPageIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Icons/Pagination Icon/back.png";
import gatewayIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gatewayLogoPortal.png";
import batteryFull from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery.png";

import battery0 from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery_0.png";
import battery25 from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery_25.png";
import battery50 from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery_50.png";
import battery75 from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery_75.png";
import battery100 from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery_100.png";

import linkedIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/link.png'

import { useSocketHook } from "../../../../Socket/useSocketHook";
import parsePinStates from "../../../../Socket/parsePinStates";
import { useDispatch, useSelector } from "react-redux";
import { getSingleDeviceData } from "../../../../Api Methods/Api";
import { serviceActions } from "../../../../store/service-Slice";

const AppView = ({ singleDevicePins, deviceUUID, setPinEdited, firmware, setHasDeviceChanged, socketPinStates, siteData, setSiteData, linkedTo }) => {
    
    const [showEditPinView, setShowEditPinView] = useState(false);
    const [showEditPinForm, setShowEditPinForm] = useState(false);
    console.log(singleDevicePins)
    const portalName = siteData.data[0].tag !== "" ? siteData.data[0].tag : "No name set"
    const DeviceDetails = useSelector(state => state.service.DeviceDetails);
    const DeviceDetailsExtras = useSelector(state => state.service.DeviceDetailsExtras);
    const gatewayBattery = siteData.data[0].gatewayBattery?.battery || null;
    const HandleShowEditPinForm = () => {
        setShowEditPinForm((prevShowEditPinForm) => !prevShowEditPinForm)
    }

    const isSetRef = useRef(false);
    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');
    const DeviceUUID = localStorage.getItem('DeviceUUID');
    const dispatch = useDispatch();
    const apiData = {
        token,
        client
    }

    const HandleToggleEditPinView = () => {
        setShowEditPinView((prevShowPinView) => !prevShowPinView);   
        setShowEditPinForm(false);
    }

    let gatewayBatteryIcon = ""
    console.log(gatewayBattery)

    if (gatewayBattery === null) {
        gatewayBatteryIcon = "";
    } else if (gatewayBattery >= 0 && gatewayBattery <= 5) {
        gatewayBatteryIcon = battery0;
    } else if (gatewayBattery > 5 && gatewayBattery <= 25) {
        gatewayBatteryIcon = battery25;
    } else if (gatewayBattery > 25 && gatewayBattery <= 50) {
        gatewayBatteryIcon = battery50
    } else if (gatewayBattery > 50 && gatewayBattery <= 75) {
        gatewayBatteryIcon = battery75
    } else if (gatewayBattery > 75 && gatewayBattery <= 100) {
        gatewayBatteryIcon = battery100
    }

    const navigateToSite = (uuid) => {
        console.log(uuid)

    }

    return (
        <div className={classes["appView-container"]} >
           {linkedTo?.length > 0 && (
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "5px",
                    marginBottom: "10px"
                }}>

                <img
                    style={{ width: "20px", height: "20px" }}
                    src={linkedIcon}
                />

                <div>
                    {linkedTo.map((site) => (
                        <h5
                            key={site.uuid}
                            className={classes.description}
                            style={{ marginLeft: 0, marginBottom: 5 }}
                            
                        >
                            {site.type === "controlled" ? "Controlled by " : "Controlling "}
                            <a
                                href={`/Dashboard/SiteView/${site.uuid}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {site.siteId}
                            </a>
                        </h5>
                    ))}
                </div>
            </div>
            )}

            <div style={{ display: "flex", backgroundColor:"#efefef" }}>
                <div className={classes["appview-controls2"]}>
                    {showEditPinForm && 
                        <button className={classes.appViewBackArrow}  onClick={() => setShowEditPinForm(false)}>
                            <img className={classes.PreviousPageButtonImg} src={PreviousPageIcon} />
                        </button>
                    }
                    
                    <p style={{color:"#575967", fontSize:"22px", fontWeight:"500", textAlign: "center"}}>{portalName}</p>
                   
                    <p style={{color:"#999999", marginTop:"40px", fontSize:"16px", fontWeight:"600"}}>{siteData.data[0].key}</p>
                    
                    <button className={`${classes.ToggleEditPinView} ${showEditPinView && classes.ToggleEditPinViewActive}`} onClick={HandleToggleEditPinView}>
                        <img className={showEditPinView ? classes.activeImg : classes.img} src={EditSiteIcon} />
                    </button>
                </div>
            </div>
            { gatewayBattery && <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap:"5px", paddingTop:"8px", backgroundColor:"#efefef" }}>
                <img style={{width:"25px"}}src={gatewayIcon}/>
                <img style={{width:"25px", filter: "invert(80%)"}}src={gatewayBatteryIcon}/>
            </div>}
            
            {showEditPinView ? <EditPinsView singleDevicePins={singleDevicePins} HandleToggleEditPinView={HandleToggleEditPinView} showEditPinForm={showEditPinForm} setShowEditPinForm={setShowEditPinForm} HandleShowEditPinForm={HandleShowEditPinForm} setPinEdited={setPinEdited} siteData={siteData} setSiteData={setSiteData} DeviceDetails={DeviceDetails} DeviceDetailsExtra={DeviceDetailsExtras}/>
                :
                <PinsView singleDevicePins={singleDevicePins} sokectPinStates={socketPinStates} firmware={firmware} />
            }
        </div>
    );
}


export default AppView;

// const HandleResponseData = (result) => {
//     const OutPutPins = [5, 6, 13, 19, 25, 26, 27, 28];

//     const {
//         id,
//         name,
//         mac,
//         key,
//         ip,
//         host,
//         uuid,
//         online,
//         created,
//         lastLoggedIn,
//         status,
//         tag,
//         networkType,
//         deviceDetails,
//         firmware,
//         type,
//         numInput,
//         numOutput,
//         subGroup,
//         deviceExtraDetails,
//         latestFirmware,
//         deviceName,
//         monitoredBy,
//         active,
//         liveViewEnabled,
//         scheduleOnly,
//         iglooLocks } = result.data[0];

//     // Passing Single Device Details to redux store to make these details availabe to other components. e.g. header
//     const DeviceDetailsParsed = JSON.parse(deviceDetails);

//     // const dispatch = useDispatch();

//     const DeviceExtraDetailsParsed = JSON.parse(deviceExtraDetails);

//     // dispatch(serviceActions.setDeviceDetails([DeviceDetailsParsed, id, DeviceExtraDetailsParsed]));

//     const allPinsNotificationActive = DeviceDetailsParsed.allPinsNotificationActive;
//     const allPinsNotificationSound = DeviceDetailsParsed.allPinsNotificationSound;
//     const camectIntegrationType = DeviceDetailsParsed.camectIntegrationType;
//     const singleDeviceName = DeviceDetailsParsed.name;
//     const offlineNotificationActive = DeviceDetailsParsed.offlineNotificationActive;
//     const offlineNotificationSound = DeviceDetailsParsed.offlineNotificationSound;
//     const onlineNotificationActive = DeviceDetailsParsed.onlineNotificationActive;
//     const onlineNotificationSound = DeviceDetailsParsed.onlineNotificationSound;
//     const polarity = DeviceDetailsParsed.polarity;
//     const polarityReason = DeviceDetailsParsed.polarityReason;
    

//     const singleDeviceSettingData = { online, numOutput, numInput, allPinsNotificationActive, allPinsNotificationSound, camectIntegrationType, singleDeviceName, offlineNotificationActive, onlineNotificationActive, offlineNotificationSound, onlineNotificationSound, polarity, polarityReason, iglooLocks, monitoredBy, active, liveViewEnabled, scheduleOnly }

//     // Parsing the Pins out into OutPut Pins / Input Pins - also added the pin number as a property to the OutPut Object.
//     const DeviceOutputPins = OutPutPins.map((output) => { const value = DeviceDetailsParsed[output]; return { ...value, Pin: output }; }).filter((obj) => obj !== undefined);
//     let InputPins;
//     if (numInput != 0) {
//         let DeviceInputPins;
//         if (numInput == 4) {
//             const InputsPins = [21, 20, 16, 12];
//             DeviceInputPins = InputsPins.map((input) => { const value = DeviceDetailsParsed[input]; return { ...value, Pin: input }; }).filter((obj) => obj !== undefined);
//         } else if (numInput == 8) {
//             const InputsPins = [21, 20, 16, 12, 4, 3, 2, 1];
//             DeviceInputPins = InputsPins.map((input) => { const value = DeviceDetailsParsed[input]; return { ...value, Pin: input }; }).filter((obj) => obj !== undefined);
//         }

//         //Input Device Icons
//         let InputDeviceIcons;
//         if (numInput == 4) {
//             const InputsPins = [21, 20, 16, 12];
//             //Input Device Icons
//             InputDeviceIcons = InputsPins.map((input) => JSON.parse(deviceExtraDetails)[input]).filter((value) => value !== undefined);
//         } else if (numInput == 8) {
//             const InputsPins = [21, 20, 16, 12, 4, 3, 2, 1];
//             InputDeviceIcons = InputsPins.map((input) => JSON.parse(deviceExtraDetails)[input]).filter((value) => value !== undefined);
//         }
//         const arrayOfInputDeviceIcons = Object.values(InputDeviceIcons);
//         const arrayOfInputDeviceIconsValues = arrayOfInputDeviceIcons.map(obj => obj.icon);

//         // debugger;
//         InputPins = DeviceInputPins.map((item, index) => {
//             let icon = arrayOfInputDeviceIconsValues[index];
//             if (icon.includes('.png')) {
//                 // //slice off .png 
//                 icon = icon.slice(0, -4) /*+ '.svg';*/
//             } else {
//                 icon = icon /*+ '.svg';*/
//             }

//             return { ...item, icon };
//         });

//     }
//     //Output Device Icons
//     const OutputDeviceIcons = OutPutPins.map((output) => JSON.parse(deviceExtraDetails)[output]).filter((value) => value !== undefined);
//     const arrayOfOutputDeviceIcons = Object.values(OutputDeviceIcons);
//     const arrayOfOutputDeviceIconsValues = arrayOfOutputDeviceIcons.map(obj => obj.icon);

//     const OutputPins = DeviceOutputPins.map((item, index) => {
//         let icon = arrayOfOutputDeviceIconsValues[index];
//         let DeviceUUID = uuid;
//         let DeviceType = type;
//         if (icon.includes('.png')) {
//             icon = icon.slice(0, -4)
//         } else {
//             icon = icon
//         }
//         return { ...item, icon, DeviceUUID, DeviceType };
//     });

//     const ResponseData = [
//         { OutputPins, InputPins, singleDeviceSettingData },
//         { id, name, mac, key, ip, host, uuid, online, created, lastLoggedIn, status, tag, networkType, firmware, type, subGroup, numInput, numOutput, latestFirmware, deviceName, monitoredBy, active, liveViewEnabled, scheduleOnly }
//     ]
//     return ResponseData;
// }